// @theme component
export const enum BaccaratValues {
    Player = 'P',
    Bank = 'B',
    Tie = 'T',
    ShoeChange = 'SC',
    WithTie = 'WithTie',
}

export type BaccaratBaseValues = Exclude<BaccaratValues, BaccaratValues.ShoeChange>;
